import axiosInstance from "../App/axiosInstance";

// get order list
export const getOrderListApi = async (data) => {
  const response = await axiosInstance.get(`/order`, { params: data });
  return response.data;
};
